var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEventAvailable = function SvgEventAvailable(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m10.825 18.3-3.45-3.425 1.05-1.05 2.4 2.35 4.6-4.6 1.05 1.075zM4.5 22q-.6 0-1.05-.45T3 20.5V5q0-.6.45-1.05T4.5 3.5h1.625V2H7.75v1.5h8.5V2h1.625v1.5H19.5q.6 0 1.05.45T21 5v15.5q0 .6-.45 1.05T19.5 22zm0-1.5h15V9.75h-15zm0-12.25h15V5h-15z"
  })));
};
export default SvgEventAvailable;